<div class="drill-path" [ngClass]="{ 'drill-path-grids' : ['grid', 'costing-grid'].includes(analyzeView)}">

  @if (showAllToggleFilter) {
    <mds-filter
      class="filter-margin"
      [slideChecked]="showAllData?.value"
      [slideSize]="'small'"
      [filterLabel]="'Show all data'"
      [showSlideToggle]="true"
      [toggleAriaLabel]="'Show all data'"
      [filterIconInteractive]="false"
      [filterIcon]="null"
      (onSlideToggleChange)="onShowAllToggle($event)"
      >
    </mds-filter>
  }

  @if (breadcrumbData?.length) {
    <mds-breadcrumb
      class="filter-margin"
      [items]="breadcrumbData"
      [maximumVisibleItems]="3"
      (selectedItemChanged)="breadcrumbSelect($event)">
    </mds-breadcrumb>
  }

  @if (analyzeView === 'sankey') {
    <mds-filter
      class="filter-margin"
      [slideChecked]="groupLowImpactNodes?.value"
      [slideDisabled]="groupLowImpactNodes?.disabled"
      [slideSize]="'small'"
      [filterLabel]="'Group low impact nodes'"
      [showSlideToggle]="true"
      [toggleAriaLabel]="'Group low impact nodes'"
      [filterIconInteractive]="false"
      [filterIcon]="null"
      (onSlideToggleChange)="onGroupSmallNodesToggle($event)"
      >
    </mds-filter>
  }

  @if (['sankey', 'graph'].includes(analyzeView) && showSetDefaultView) {
    <div class="path back-to-default">
      <a aria-label="Back to default layout" role="button" (click)="backToDefaultView(); $event.preventDefault();">Back to
      default layout</a>
    </div>
  }
  @if (tariffForm) {
    <mds-filter
      class="filter-margin"
      [slideChecked]="tariffControl?.value"
      [slideSize]="'small'"
      [filterLabel]="'Include tariffs in results'"
      [showSlideToggle]="true"
      [toggleAriaLabel]="'Include tariffs in results'"
      [filterIconInteractive]="false"
      [filterIcon]="null"
      (onSlideToggleChange)="onTariffToggle($event)"
    ></mds-filter>
  }
  @if (tariffForm) {
    <mds-dropdown-menu
      [minWidth]="'275px'"
      [iconPrefix]="'plus'"
      [showSearch]="true"
      [placeholder]="'Search'"
      [text]="selectedTariff?.name || null"
      [helperTextPre]="tariffForm.title"
      [options]="allTariffOptions"
      [selectedValue]="[selectedTariff]"
      (searchValueChange)="searchValueChange($event)"
      (selectedValueChange)="onTariffSelection($event)"
    ></mds-dropdown-menu>
  }

</div>
